interface ISpinnerProps {
  color?: string;
  size?: string;
}

const Spinner: React.FC<ISpinnerProps> = ({ color, size }) => {
  return (
    <div className="flex justify-center items-center">
      <div className={`animate-spin motion-reduce:animate-none rounded-full h-${size || 8} w-${size || 8} border-b-2 border-${color || "tt-yellow"}`}></div>
    </div>
  );
};

export default Spinner;
